export default __webpack_public_path__ + "static/media/bannerB.751c3bd3.png";